import { Injectable, Injector } from '@angular/core';
import { BaseQuestion } from '../../shared/extended-class/base-question';
import { SectionWiseService } from '../service/section-wise.service';
import { SwProcessStateService } from '../service/ui/sw-process-state.service';
import { CustomerJourneyService } from 'src/app/customer-journey/service/customer-journey.service';

@Injectable({
  providedIn: 'root'
})
export class BaseSWQuestion extends BaseQuestion {
  protected swProcessStateService: SwProcessStateService;
  protected sectionWiseService: SectionWiseService;
  protected customerJourneyService: CustomerJourneyService;

  constructor(serviceInjector: Injector) {
    super(serviceInjector);
    this.swProcessStateService = serviceInjector.get(SwProcessStateService);
    this.sectionWiseService = serviceInjector.get(SectionWiseService);
    this.customerJourneyService = serviceInjector.get(CustomerJourneyService);
  }

  protected addGTMAnswer(questionKey: string, answerStr: string) {
    this.gtmDatalayerUiService.addAnswer('wiseanswer', questionKey, answerStr).toPromise();
  }
}
